var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgBrandTrustHero = function SvgBrandTrustHero(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1800 1459",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1748.93 849.25c0-9.771 7.917-17.692 17.679-17.692 9.763 0 17.679 7.921 17.679 17.692s-7.916 17.688-17.679 17.688c-9.762 0-17.679-7.917-17.679-17.688Z",
    style: {
      fill: "url(#brand-trust-hero_svg__a)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1756.79 731.313c0-5.425 4.395-9.825 9.82-9.825 5.425 0 9.821 4.4 9.821 9.825 0 5.429-4.396 9.829-9.821 9.829s-9.82-4.4-9.82-9.829Z",
    style: {
      fill: "url(#brand-trust-hero_svg__b)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1756.79 613.379c0-5.429 4.395-9.829 9.82-9.829 5.425 0 9.821 4.4 9.821 9.829s-4.396 9.829-9.821 9.829-9.82-4.4-9.82-9.829Z",
    style: {
      fill: "url(#brand-trust-hero_svg__c)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748.93 495.446c0-9.771 7.917-17.692 17.679-17.692 9.763 0 17.679 7.921 17.679 17.692 0 9.767-7.916 17.687-17.679 17.687-9.762 0-17.679-7.921-17.679-17.687Z",
    style: {
      fill: "url(#brand-trust-hero_svg__d)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1756.79 1320.99c0-5.43 4.395-9.83 9.82-9.83 5.425 0 9.821 4.4 9.821 9.829 0 5.43-4.396 9.83-9.821 9.83s-9.82-4.4-9.82-9.83Z",
    style: {
      fill: "url(#brand-trust-hero_svg__e)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1756.79 1203.05c0-5.429 4.395-9.829 9.82-9.829 5.425 0 9.821 4.4 9.821 9.829 0 5.425-4.396 9.825-9.821 9.825s-9.82-4.4-9.82-9.825Z",
    style: {
      fill: "url(#brand-trust-hero_svg__f)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1756.79 1085.12c0-5.425 4.395-9.825 9.82-9.825 5.425 0 9.821 4.4 9.821 9.825 0 5.429-4.396 9.829-9.821 9.829s-9.82-4.4-9.82-9.829Z",
    style: {
      fill: "url(#brand-trust-hero_svg__g)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1756.79 967.183c0-5.429 4.395-9.829 9.82-9.829 5.425 0 9.821 4.4 9.821 9.829 0 5.43-4.396 9.83-9.821 9.83s-9.82-4.4-9.82-9.83Z",
    style: {
      fill: "url(#brand-trust-hero_svg__h)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1631.07 849.25c0-9.771 7.917-17.692 17.679-17.692 9.762 0 17.679 7.921 17.679 17.692s-7.917 17.688-17.679 17.688c-9.763 0-17.679-7.917-17.679-17.688Z",
    style: {
      fill: "url(#brand-trust-hero_svg__i)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1631.07 731.313c0-9.767 7.917-17.688 17.679-17.688 9.762 0 17.679 7.921 17.679 17.688 0 9.77-7.917 17.691-17.679 17.691-9.763 0-17.679-7.921-17.679-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__j)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1631.07 613.379c0-9.771 7.917-17.692 17.679-17.692 9.762 0 17.679 7.921 17.679 17.692s-7.917 17.692-17.679 17.692c-9.763 0-17.679-7.921-17.679-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__k)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1638.93 495.446c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829c0 5.425-4.396 9.825-9.821 9.825s-9.821-4.4-9.821-9.825Z",
    style: {
      fill: "url(#brand-trust-hero_svg__l)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1631.07 1320.99c0-9.771 7.917-17.692 17.679-17.692 9.762 0 17.679 7.921 17.679 17.691 0 9.771-7.917 17.692-17.679 17.692-9.763 0-17.679-7.921-17.679-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__m)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1638.93 1203.05c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829c0 5.425-4.396 9.825-9.821 9.825s-9.821-4.4-9.821-9.825Z",
    style: {
      fill: "url(#brand-trust-hero_svg__n)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1638.93 1085.12c0-5.425 4.396-9.825 9.821-9.825s9.821 4.4 9.821 9.825c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829Z",
    style: {
      fill: "url(#brand-trust-hero_svg__o)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1638.93 967.183c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829c0 5.43-4.396 9.83-9.821 9.83s-9.821-4.4-9.821-9.83Z",
    style: {
      fill: "url(#brand-trust-hero_svg__p)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.21 849.25c0-9.771 7.916-17.692 17.679-17.692 9.766 0 17.679 7.921 17.679 17.692s-7.913 17.688-17.679 17.688c-9.763 0-17.679-7.917-17.679-17.688Z",
    style: {
      fill: "url(#brand-trust-hero_svg__q)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.07 731.313c0-5.425 4.4-9.825 9.821-9.825 5.425 0 9.821 4.4 9.821 9.825 0 5.429-4.396 9.829-9.821 9.829-5.421 0-9.821-4.4-9.821-9.829Z",
    style: {
      fill: "url(#brand-trust-hero_svg__r)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.21 613.379c0-9.771 7.916-17.692 17.679-17.692 9.766 0 17.679 7.921 17.679 17.692s-7.913 17.692-17.679 17.692c-9.763 0-17.679-7.921-17.679-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__s)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.07 495.446c0-5.429 4.4-9.829 9.821-9.829 5.425 0 9.821 4.4 9.821 9.829 0 5.425-4.396 9.825-9.821 9.825-5.421 0-9.821-4.4-9.821-9.825Z",
    style: {
      fill: "url(#brand-trust-hero_svg__t)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.21 1320.99c0-9.771 7.916-17.692 17.679-17.692 9.766 0 17.679 7.921 17.679 17.691 0 9.771-7.913 17.692-17.679 17.692-9.763 0-17.679-7.921-17.679-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__u)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.07 1203.05c0-5.429 4.4-9.829 9.821-9.829 5.425 0 9.821 4.4 9.821 9.829 0 5.425-4.396 9.825-9.821 9.825-5.421 0-9.821-4.4-9.821-9.825Z",
    style: {
      fill: "url(#brand-trust-hero_svg__v)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.07 1085.12c0-5.425 4.4-9.825 9.821-9.825 5.425 0 9.821 4.4 9.821 9.825 0 5.429-4.396 9.829-9.821 9.829-5.421 0-9.821-4.4-9.821-9.829Z",
    style: {
      fill: "url(#brand-trust-hero_svg__w)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.07 967.183c0-5.429 4.4-9.829 9.821-9.829 5.425 0 9.821 4.4 9.821 9.829 0 5.43-4.396 9.83-9.821 9.83-5.421 0-9.821-4.4-9.821-9.83Z",
    style: {
      fill: "url(#brand-trust-hero_svg__x)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.36 849.25c0-9.771 7.913-17.692 17.68-17.692 9.762 0 17.679 7.921 17.679 17.692s-7.917 17.688-17.679 17.688c-9.767 0-17.68-7.917-17.68-17.688Z",
    style: {
      fill: "url(#brand-trust-hero_svg__y)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.36 731.313c0-9.767 7.913-17.688 17.68-17.688 9.762 0 17.679 7.921 17.679 17.688 0 9.77-7.917 17.691-17.679 17.691-9.767 0-17.68-7.921-17.68-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__z)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403.21 613.379c0-5.429 4.4-9.829 9.825-9.829 5.42 0 9.82 4.4 9.82 9.829s-4.4 9.829-9.82 9.829c-5.425 0-9.825-4.4-9.825-9.829Z",
    style: {
      fill: "url(#brand-trust-hero_svg__A)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.36 495.446c0-9.771 7.913-17.692 17.68-17.692 9.762 0 17.679 7.921 17.679 17.692 0 9.767-7.917 17.687-17.679 17.687-9.767 0-17.68-7.921-17.68-17.687Z",
    style: {
      fill: "url(#brand-trust-hero_svg__B)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.5 1320.99c0-14.113 11.433-25.555 25.538-25.555 14.1 0 25.533 11.442 25.533 25.554 0 14.113-11.433 25.555-25.533 25.555-14.105 0-25.538-11.442-25.538-25.555Z",
    style: {
      fill: "url(#brand-trust-hero_svg__C)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.36 1203.05c0-9.771 7.913-17.691 17.68-17.691 9.762 0 17.679 7.92 17.679 17.691 0 9.771-7.917 17.688-17.679 17.688-9.767 0-17.68-7.917-17.68-17.688Z",
    style: {
      fill: "url(#brand-trust-hero_svg__D)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403.21 1085.12c0-5.425 4.4-9.825 9.825-9.825 5.42 0 9.82 4.4 9.82 9.825 0 5.429-4.4 9.829-9.82 9.829-5.425 0-9.825-4.4-9.825-9.829Z",
    style: {
      fill: "url(#brand-trust-hero_svg__E)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.36 967.183c0-9.77 7.913-17.691 17.68-17.691 9.762 0 17.679 7.921 17.679 17.691 0 9.771-7.917 17.692-17.679 17.692-9.767 0-17.68-7.921-17.68-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__F)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1269.64 849.25c0-14.112 11.433-25.554 25.537-25.554s25.534 11.442 25.534 25.554c-.001 14.113-11.43 25.55-25.534 25.55s-25.537-11.437-25.537-25.55Z",
    style: {
      fill: "url(#brand-trust-hero_svg__G)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1269.64 731.313c0-14.113 11.433-25.55 25.537-25.55s25.534 11.437 25.534 25.549c-.001 14.113-11.43 25.555-25.534 25.555s-25.537-11.442-25.537-25.554Z",
    style: {
      fill: "url(#brand-trust-hero_svg__H)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.5 613.379c0-9.771 7.917-17.692 17.679-17.692 9.763 0 17.679 7.921 17.679 17.692s-7.916 17.692-17.679 17.692c-9.762 0-17.679-7.921-17.679-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__I)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.5 495.446c0-9.771 7.917-17.692 17.679-17.692 9.763 0 17.679 7.921 17.679 17.692 0 9.767-7.916 17.687-17.679 17.687-9.762 0-17.679-7.921-17.679-17.687Z",
    style: {
      fill: "url(#brand-trust-hero_svg__J)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.5 1320.99c0-9.771 7.917-17.692 17.679-17.692 9.763 0 17.679 7.921 17.679 17.691 0 9.771-7.916 17.692-17.679 17.692-9.762 0-17.679-7.921-17.679-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__K)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.5 1203.05c0-9.771 7.917-17.691 17.679-17.691 9.763 0 17.679 7.92 17.679 17.691 0 9.771-7.916 17.688-17.679 17.688-9.762 0-17.679-7.917-17.679-17.688Z",
    style: {
      fill: "url(#brand-trust-hero_svg__L)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.5 1085.12c0-9.767 7.917-17.688 17.679-17.688 9.763 0 17.679 7.921 17.679 17.688 0 9.771-7.916 17.691-17.679 17.691-9.762 0-17.679-7.92-17.679-17.691Z",
    style: {
      fill: "url(#brand-trust-hero_svg__M)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.5 967.183c0-9.77 7.917-17.691 17.679-17.691 9.763 0 17.679 7.921 17.679 17.691 0 9.771-7.916 17.692-17.679 17.692-9.762 0-17.679-7.921-17.679-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__N)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.64 849.25c0-9.771 7.916-17.692 17.679-17.692 9.762 0 17.679 7.921 17.679 17.692s-7.917 17.688-17.679 17.688c-9.763 0-17.679-7.917-17.679-17.688Z",
    style: {
      fill: "url(#brand-trust-hero_svg__O)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.79 731.313c-.001-14.113 11.433-25.55 25.533-25.55 14.104 0 25.537 11.437 25.537 25.549 0 14.113-11.433 25.555-25.537 25.555-14.1 0-25.534-11.442-25.534-25.554Z",
    style: {
      fill: "url(#brand-trust-hero_svg__P)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.64 613.379c0-9.771 7.916-17.692 17.679-17.692 9.762 0 17.679 7.921 17.679 17.692s-7.917 17.692-17.679 17.692c-9.763 0-17.679-7.921-17.679-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__Q)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.64 495.446c0-9.771 7.916-17.692 17.679-17.692 9.762 0 17.679 7.921 17.679 17.692 0 9.767-7.917 17.687-17.679 17.687-9.763 0-17.679-7.921-17.679-17.687Z",
    style: {
      fill: "url(#brand-trust-hero_svg__R)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.79 1320.99c-.001-14.113 11.429-25.555 25.533-25.555 14.104 0 25.537 11.442 25.537 25.554 0 14.113-11.433 25.555-25.537 25.555s-25.534-11.442-25.534-25.555Z",
    style: {
      fill: "url(#brand-trust-hero_svg__S)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.5 1203.05c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829c0 5.425-4.396 9.825-9.821 9.825s-9.821-4.4-9.821-9.825Z",
    style: {
      fill: "url(#brand-trust-hero_svg__T)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.5 1085.12c0-5.425 4.396-9.825 9.821-9.825s9.821 4.4 9.821 9.825c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829Z",
    style: {
      fill: "url(#brand-trust-hero_svg__U)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.5 967.183c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829c0 5.43-4.396 9.83-9.821 9.83s-9.821-4.4-9.821-9.83Z",
    style: {
      fill: "url(#brand-trust-hero_svg__V)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 849.25c0-16.283 13.192-29.483 29.463-29.483 16.275 0 29.466 13.2 29.466 29.483s-13.191 29.483-29.466 29.483c-16.271 0-29.463-13.2-29.463-29.483Z",
    style: {
      fill: "url(#brand-trust-hero_svg__W)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.93 731.313c0-14.113 11.434-25.55 25.534-25.55 14.104 0 25.537 11.437 25.537 25.549 0 14.113-11.433 25.555-25.538 25.555-14.1 0-25.533-11.442-25.533-25.554Z",
    style: {
      fill: "url(#brand-trust-hero_svg__X)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.93 613.379c0-14.112 11.434-25.554 25.534-25.554 14.104 0 25.537 11.442 25.537 25.554 0 14.113-11.433 25.554-25.538 25.554-14.1 0-25.533-11.441-25.533-25.554Z",
    style: {
      fill: "url(#brand-trust-hero_svg__Y)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.79 495.446c0-9.771 7.912-17.692 17.675-17.692 9.766 0 17.679 7.921 17.679 17.692 0 9.767-7.913 17.687-17.679 17.687-9.763 0-17.675-7.921-17.675-17.687Z",
    style: {
      fill: "url(#brand-trust-hero_svg__Z)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.79 1320.99c0-9.771 7.912-17.692 17.675-17.692 9.766 0 17.679 7.921 17.679 17.691 0 9.771-7.913 17.692-17.679 17.692-9.763 0-17.675-7.921-17.675-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aa)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.79 1203.05c0-9.771 7.912-17.691 17.675-17.691 9.766 0 17.679 7.92 17.679 17.691 0 9.771-7.913 17.688-17.679 17.688-9.763 0-17.675-7.917-17.675-17.688Z",
    style: {
      fill: "url(#brand-trust-hero_svg__ab)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.64 1085.12c0-5.425 4.4-9.825 9.821-9.825 5.425 0 9.825 4.4 9.825 9.825 0 5.429-4.4 9.829-9.825 9.829-5.421 0-9.821-4.4-9.821-9.829Z",
    style: {
      fill: "url(#brand-trust-hero_svg__ac)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.79 967.183c0-9.77 7.912-17.691 17.675-17.691 9.766 0 17.679 7.921 17.679 17.691 0 9.771-7.913 17.692-17.679 17.692-9.763 0-17.675-7.921-17.675-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__ad)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.929 849.25c0-9.771 7.917-17.692 17.679-17.692 9.763 0 17.68 7.921 17.68 17.692s-7.917 17.688-17.68 17.688c-9.762 0-17.679-7.917-17.679-17.688Z",
    style: {
      fill: "url(#brand-trust-hero_svg__ae)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.142 731.313c0-16.284 13.191-29.484 29.466-29.484 16.271 0 29.463 13.2 29.463 29.484 0 16.283-13.192 29.483-29.463 29.483-16.275 0-29.466-13.2-29.466-29.483Z",
    style: {
      fill: "url(#brand-trust-hero_svg__af)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.071 613.379c0-14.112 11.433-25.554 25.537-25.554 14.1 0 25.534 11.442 25.534 25.554 0 14.113-11.434 25.554-25.534 25.554-14.104 0-25.537-11.441-25.537-25.554Z",
    style: {
      fill: "url(#brand-trust-hero_svg__ag)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.071 495.446c0-14.113 11.433-25.554 25.537-25.554 14.1 0 25.534 11.441 25.534 25.554 0 14.112-11.434 25.55-25.534 25.55-14.104 0-25.537-11.438-25.537-25.55Z",
    style: {
      fill: "url(#brand-trust-hero_svg__ah)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.929 1320.99c0-9.771 7.913-17.692 17.679-17.692 9.763 0 17.68 7.921 17.68 17.691 0 9.771-7.917 17.692-17.68 17.692-9.766 0-17.679-7.921-17.679-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__ai)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.929 1203.05c0-9.771 7.913-17.691 17.679-17.691 9.763 0 17.68 7.92 17.68 17.691 0 9.771-7.917 17.688-17.68 17.688-9.766 0-17.679-7.917-17.679-17.688Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aj)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.929 1085.12c0-9.767 7.917-17.688 17.679-17.688 9.763 0 17.68 7.921 17.68 17.688 0 9.771-7.917 17.691-17.68 17.691-9.762 0-17.679-7.92-17.679-17.691Z",
    style: {
      fill: "url(#brand-trust-hero_svg__ak)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.929 967.183c0-9.77 7.917-17.691 17.679-17.691 9.763 0 17.68 7.921 17.68 17.691 0 9.771-7.917 17.692-17.68 17.692-9.762 0-17.679-7.921-17.679-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__al)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.071 849.25c0-9.771 7.917-17.692 17.679-17.692 9.763 0 17.679 7.921 17.679 17.692s-7.916 17.688-17.679 17.688c-9.762 0-17.679-7.917-17.679-17.688Z",
    style: {
      fill: "url(#brand-trust-hero_svg__am)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.071 731.313c0-9.767 7.917-17.688 17.679-17.688 9.763 0 17.679 7.921 17.679 17.688 0 9.77-7.916 17.691-17.679 17.691-9.762 0-17.679-7.921-17.679-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__an)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.217 613.379c0-14.112 11.429-25.554 25.533-25.554 14.104 0 25.538 11.442 25.538 25.554 0 14.113-11.434 25.554-25.538 25.554-14.104 0-25.537-11.441-25.533-25.554Z",
    style: {
      fill: "url(#brand-trust-hero_svg__ao)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.071 495.446c0-9.771 7.917-17.692 17.679-17.692 9.763 0 17.679 7.921 17.679 17.692 0 9.767-7.916 17.687-17.679 17.687-9.762 0-17.679-7.921-17.679-17.687Z",
    style: {
      fill: "url(#brand-trust-hero_svg__ap)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.213 1320.99c0-14.113 11.433-25.555 25.537-25.555s25.538 11.442 25.538 25.554c0 14.113-11.434 25.555-25.538 25.555-14.104 0-25.537-11.442-25.537-25.555Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aq)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.213 1203.05c0-14.112 11.433-25.554 25.537-25.554s25.538 11.442 25.538 25.554c0 14.113-11.434 25.55-25.538 25.55-14.104 0-25.537-11.437-25.537-25.55Z",
    style: {
      fill: "url(#brand-trust-hero_svg__ar)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.213 1085.12c0-14.113 11.433-25.55 25.537-25.55s25.538 11.437 25.538 25.55c0 14.112-11.434 25.554-25.538 25.554-14.104 0-25.537-11.442-25.537-25.554Z",
    style: {
      fill: "url(#brand-trust-hero_svg__as)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.929 967.183c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829c0 5.43-4.396 9.83-9.821 9.83s-9.821-4.4-9.821-9.83Z",
    style: {
      fill: "url(#brand-trust-hero_svg__at)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.071 849.25c0-5.429 4.4-9.829 9.821-9.829 5.425 0 9.82 4.4 9.82 9.829 0 5.425-4.395 9.825-9.82 9.825-5.421 0-9.821-4.4-9.821-9.825Z",
    style: {
      fill: "url(#brand-trust-hero_svg__au)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.213 731.313c0-9.767 7.916-17.688 17.679-17.688 9.766 0 17.679 7.921 17.679 17.688 0 9.77-7.913 17.691-17.679 17.691-9.763 0-17.679-7.921-17.679-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__av)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.358 613.379c0-14.112 11.434-25.554 25.534-25.554 14.104 0 25.537 11.442 25.537 25.554 0 14.113-11.433 25.554-25.537 25.554-14.1 0-25.534-11.441-25.534-25.554Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aw)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.358 495.446c0-14.113 11.434-25.554 25.534-25.554 14.104 0 25.537 11.441 25.537 25.554 0 14.112-11.433 25.55-25.537 25.55-14.1 0-25.534-11.438-25.534-25.55Z",
    style: {
      fill: "url(#brand-trust-hero_svg__ax)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.358 1320.99c0-14.113 11.434-25.555 25.534-25.555 14.104 0 25.537 11.442 25.537 25.554 0 14.113-11.433 25.555-25.537 25.555-14.1 0-25.534-11.442-25.534-25.555Z",
    style: {
      fill: "url(#brand-trust-hero_svg__ay)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.358 1203.05c0-14.112 11.434-25.554 25.534-25.554 14.104 0 25.537 11.442 25.537 25.554 0 14.113-11.433 25.55-25.537 25.55-14.1 0-25.534-11.437-25.534-25.55Z",
    style: {
      fill: "url(#brand-trust-hero_svg__az)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.213 1085.12c0-9.767 7.916-17.688 17.679-17.688 9.766 0 17.679 7.921 17.679 17.688 0 9.771-7.913 17.691-17.679 17.691-9.763 0-17.679-7.92-17.679-17.691Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aA)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.213 967.183c0-9.77 7.916-17.691 17.679-17.691 9.766 0 17.679 7.921 17.679 17.691 0 9.771-7.913 17.692-17.679 17.692-9.763 0-17.679-7.921-17.679-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aB)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.213 849.25c0-5.429 4.4-9.829 9.825-9.829 5.42 0 9.82 4.4 9.82 9.829 0 5.425-4.4 9.825-9.821 9.825-5.424 0-9.825-4.4-9.825-9.825Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aC)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.213 731.313c0-5.425 4.4-9.825 9.825-9.825 5.42 0 9.82 4.4 9.82 9.825 0 5.429-4.4 9.829-9.821 9.829-5.424 0-9.825-4.4-9.825-9.829Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aD)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.358 613.379c0-9.771 7.913-17.692 17.679-17.692 9.763 0 17.68 7.921 17.68 17.692s-7.917 17.692-17.679 17.692c-9.767 0-17.68-7.921-17.68-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aE)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.571 495.446c0-16.284 13.192-29.483 29.466-29.483 16.271 0 29.463 13.2 29.463 29.483s-13.192 29.483-29.462 29.483c-16.275 0-29.467-13.2-29.467-29.483Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aF)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.5 1320.99c0-14.113 11.433-25.555 25.538-25.555 14.1 0 25.533 11.442 25.533 25.554 0 14.113-11.433 25.555-25.534 25.555-14.104 0-25.537-11.442-25.537-25.555Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aG)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.358 1203.05c0-9.771 7.913-17.691 17.679-17.691 9.763 0 17.676 7.92 17.676 17.691 0 9.771-7.913 17.688-17.676 17.688-9.766 0-17.679-7.917-17.679-17.688Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aH)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.5 1085.12c0-14.113 11.433-25.55 25.538-25.55 14.1 0 25.533 11.437 25.533 25.55 0 14.112-11.433 25.554-25.534 25.554-14.104 0-25.537-11.442-25.537-25.554Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aI)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.213 967.183c0-5.429 4.4-9.829 9.825-9.829 5.42 0 9.82 4.4 9.82 9.829 0 5.43-4.4 9.83-9.821 9.83-5.424 0-9.825-4.4-9.825-9.83Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aJ)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.358 849.25c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829c0 5.425-4.396 9.825-9.821 9.825s-9.821-4.4-9.821-9.825Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aK)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.5 731.313c0-9.767 7.917-17.688 17.679-17.688 9.763 0 17.679 7.921 17.679 17.688 0 9.77-7.916 17.691-17.679 17.691-9.762 0-17.679-7.921-17.679-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aL)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.358 613.379c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829-4.396 9.829-9.821 9.829-9.821-4.4-9.821-9.829Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aM)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.5 495.446c0-9.771 7.917-17.692 17.679-17.692 9.763 0 17.679 7.921 17.679 17.692 0 9.767-7.916 17.687-17.679 17.687-9.762 0-17.679-7.921-17.679-17.687Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aN)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.5 1320.99c0-9.771 7.917-17.692 17.679-17.692 9.763 0 17.679 7.921 17.679 17.691 0 9.771-7.916 17.692-17.679 17.692-9.762 0-17.679-7.921-17.679-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aO)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.642 1203.05c0-14.112 11.433-25.554 25.537-25.554s25.534 11.442 25.534 25.554c0 14.113-11.43 25.55-25.534 25.55s-25.537-11.437-25.537-25.55Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aP)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.713 1085.12c0-16.284 13.191-29.484 29.466-29.484 16.271 0 29.463 13.2 29.463 29.484 0 16.283-13.192 29.483-29.463 29.483-16.275 0-29.466-13.2-29.466-29.483Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aQ)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.5 967.183c0-9.77 7.917-17.691 17.679-17.691 9.763 0 17.679 7.921 17.679 17.691 0 9.771-7.916 17.692-17.679 17.692-9.762 0-17.679-7.921-17.679-17.692Z",
    style: {
      fill: "url(#brand-trust-hero_svg__aR)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 729.167C0 327.104 327.104 0 729.167 0c402.062 0 729.166 327.104 729.166 729.167 0 402.062-327.104 729.166-729.166 729.166C327.104 1458.333 0 1131.229 0 729.167Zm729.167 640.937c353.5 0 640.937-287.437 640.937-640.937S1082.667 88.229 729.167 88.229v177.188c-256.23 0-463.75 207.666-463.75 463.75 0 256.083 207.666 463.75 463.75 463.75v177.187Zm463.75-640.937c-.225 256.016-207.716 463.458-463.75 463.458V968.479l-248.938-229.25h.146l75.104-81.375 173.688 159.845V265.563c152.833 0 288.458 73.791 372.604 187.833L729.458 818.125l-.145-.146v150.209l.583.583 428.021-417.083c22.441 54.645 34.98 114.386 35 177.187v.292Z",
    style: {
      fill: "#7ec2fa"
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__a",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__b",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__c",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__d",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__e",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__f",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__g",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__h",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__i",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__j",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__k",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__l",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__m",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__n",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__o",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__p",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__q",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__r",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__s",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__t",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__u",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__v",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__w",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__x",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__y",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__z",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__A",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__B",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__C",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__D",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__E",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__F",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__G",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__H",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__I",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__J",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__K",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__L",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__M",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__N",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__O",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__P",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__Q",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__R",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__S",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__T",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__U",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__V",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__W",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__X",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__Y",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__Z",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aa",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__ab",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__ac",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__ad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__ae",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__af",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__ag",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__ah",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__ai",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aj",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__ak",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__al",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__am",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__an",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__ao",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__ap",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aq",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__ar",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__as",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__at",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__au",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__av",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aw",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__ax",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__ay",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__az",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aA",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aB",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aC",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aD",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aE",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aF",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aG",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aH",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aI",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aJ",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aK",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aL",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aM",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aN",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aO",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aP",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aQ",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-trust-hero_svg__aR",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1619.853) rotate(33.895 .814 -2.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  }))));
};
export default SvgBrandTrustHero;